import { render, staticRenderFns } from "./verify_code_page.vue?vue&type=template&id=4bf97d7a"
import script from "./verify_code_page.vue?vue&type=script&lang=js"
export * from "./verify_code_page.vue?vue&type=script&lang=js"
import style0 from "./verify_code_page.vue?vue&type=style&index=0&id=4bf97d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports